// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CONTAINER */
.advanced-search-promo { padding:24px; border:1px solid #edc5ae; border-radius:18px; background:linear-gradient(135deg,#fff8f2,#f3f7fb); color:#17344f; }
.advanced-search-promo-icon { color:#b4470d; font-size:24px; margin-bottom:12px; }
.advanced-search-promo h3 { margin:0 0 12px; color:#17344f; font-size:clamp(1.2rem,3vw,1.6rem); }
.advanced-search-promo p { color:#526c80; line-height:1.7; }
.advanced-search-preview { display:flex; flex-wrap:wrap; gap:8px; margin:20px 0 10px; }
.advanced-search-preview span { display:flex; gap:8px; align-items:center; padding:9px 12px; background:#fff; border:1px solid #dce5eb; border-radius:9px; font-size:.85rem; }
.advanced-search-filter-preview { font-size:.8rem; }
.advanced-search-promo button { padding:13px 20px; margin-top:8px; border:0; border-radius:10px; background:#b4470d; color:#fff; font:inherit; font-weight:700; cursor:pointer; }
.advanced-search-promo button:hover { background:#923808; }
.advanced-search-promo button:focus-visible { outline:3px solid #17344f; outline-offset:3px; }
@media(max-width:480px) { .advanced-search-promo { padding:18px; }.advanced-search-promo button { width:100%; } }

.advanced-search {
  width: 100%;
  margin: 20px auto;
  padding: 22px;
  border-radius: 24px;

  background: rgba(255, 255, 255, .72);
  backdrop-filter: blur(20px);

  border: 1px solid rgba(255, 255, 255, .35);
  /* box-shadow:
    0 10px 30px rgba(0,0,0,.08),
    inset 0 1px 0 rgba(255,255,255,.5); */

  animation: fadeUp .45s ease;
}

.advanced-search h2 {
  margin: 0 0 20px;
  font-size: 22px;
  font-weight: 800;
  color: var(--text-100);
}

/* ROLE GRID */
.role-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 22px;
}

.role-card {
  border: none;
  cursor: pointer;
  border-radius: 20px;
  padding: 18px 12px;

  background: rgba(255, 255, 255, .6);
  border: 1px solid rgba(255, 255, 255, .35);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  transition: .25s;
}

.role-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, .08);
}

.role-card.active {
  /* background: linear-gradient(135deg, var(--primary-100), #ffc371); */
  background: var(--primary-100);

  color: white;
  transform: translateY(-4px);

  box-shadow:
    0 12px 28px rgba(0, 0, 0, .12),
    0 0 0 3px rgba(255, 255, 255, .3);
}

.role-icon {
  font-size: 24px;
}

/* FIELDS */
.dynamic-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: fadeUp .35s ease;
}

.dynamic-fields input,
.dynamic-fields select {
  width: 100%;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid #e6e6e6;
  outline: none;
  font-size: 16px;
  background: white;
  transition: .2s;
  box-sizing: border-box;
}

.dynamic-fields input:focus,
.dynamic-fields select:focus {
  border-color: var(--bg-200);
  box-shadow: 0 0 0 4px rgba(0, 0, 0, .05);
}

/* FLEX */
.flex-row {
  display: flex;
  gap: 12px;
}

.flex-row input {
  flex: 1 1;
}

/* SEARCH BUTTON */
.search-btn {
  margin-top: 8px;
  border: none;
  cursor: pointer;

  padding: 15px;
  border-radius: 16px;

  /* background: linear-gradient(
    135deg,
    var(--bg-100),
    var(--bg-200)
  ); */
  background: var(--primary-100);

  color: white;
  font-size: 15px;
  font-weight: 700;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  transition: .25s;
}

.search-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, .15);
}

/* ANIMATION */
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(18px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* MOBILE */
@media (max-width: 700px) {
  .role-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .advanced-search {
    padding: 18px;
    border-radius: 20px;
  }

  .role-card {
    padding: 16px 10px;
  }

  .role-icon {
    font-size: 22px;
  }

  .flex-row {
    flex-direction: column;
    gap: 14px;
  }
}



.search-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .35);
  backdrop-filter: blur(8px);
  z-index: 999;
  animation: fadeUp .25s ease;
}

.search-modal {
  position: absolute;
  inset: 0;
  background: white;
  overflow-y: auto;
}

.search-modal-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 18px 20px;
  border-bottom: 1px solid #eee;
}

.search-results-list {
  padding: 20px;
}

.search-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;

  padding: 14px;
  margin-bottom: 12px;

  border-radius: 18px;
  background: #fafafa;
}

.search-avatar {
  width: 55px;
  height: 55px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 700;
  color: white;

  background: var(--primary-200);
}

.search-user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.search-user-info span {
  color: #666;
  font-size: 14px;
}

.search-user-info small {
  color: #999;
}

.empty-search {
  text-align: center;
  padding: 60px 20px;
  color: #777;
}

.skeleton-user {
  display: flex;
  align-items: center;
  gap: 14px;
}

.user-lines {
  flex: 1 1;
}

.line {
  height: 15px;
  width: 70%;
  margin-bottom: 10px;
  border-radius: 8px;
}

.line.small {
  width: 45%;
}




.view-profile-btn-search {
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  background: var(--primary-100);
  color: white;
  font-size: 14px;
  font-weight: 600;
}

/* Advanced search and its result console. */
.network-page .advanced-search {
  position: relative;
  box-sizing: border-box;
  margin: 28px 0 0;
  padding: 22px;
  border: 1px solid rgba(78, 119, 153, .17);
  border-radius: 20px;
  background: #fbfcfd;
  box-shadow: 0 15px 35px rgba(30, 63, 88, .08), inset 0 1px #ffffff;
  backdrop-filter: none;
}

.network-page .advanced-search::before {
  content: "";
  position: absolute;
  top: 0;
  right: 28px;
  left: 28px;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: #4e7799;
}

.network-page .advanced-search h2 {
  margin: 1px 0 17px;
  color: #29475e;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 1.04rem;
  font-weight: 850;
  letter-spacing: -.015em;
}

.network-page .role-grid {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 9px;
  margin-bottom: 17px;
}

.network-page .role-card {
  min-height: 92px;
  padding: 12px 7px;
  border: 1px solid rgba(78, 119, 153, .14);
  border-radius: 13px;
  color: #4e7799;
  background: #f4f8fa;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .69rem;
  font-weight: 750;
  transition: .18s ease;
}

.network-page .role-card:hover {
  border-color: rgba(233, 90, 19, .28);
  color: #d84f0d;
  background: #fff8f4;
  box-shadow: 0 8px 18px rgba(30, 63, 88, .07);
  transform: translateY(-2px);
}

.network-page .role-card.active {
  border-color: #e95a13;
  color: #ffffff;
  background: #e95a13;
  box-shadow: 0 9px 19px rgba(233, 90, 19, .2);
  transform: translateY(-2px);
}

.network-page .role-card.active .role-icon svg { color: #ffffff !important; }
.network-page .role-icon { font-size: 1.05rem; }

.network-page .dynamic-fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  animation: network-fields-in .25s ease both;
}

.network-page .dynamic-fields input,
.network-page .dynamic-fields select {
  min-width: 0;
  margin: 0;
  padding: 11px 12px;
  border: 1px solid rgba(78, 119, 153, .18);
  border-radius: 11px;
  color: #29475e;
  background: #f1f5f7;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .77rem;
  font-weight: 600;
}

.network-page .dynamic-fields input:focus,
.network-page .dynamic-fields select:focus {
  border-color: #e95a13;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);
}

.network-page .dynamic-fields .flex-row { grid-column: span 3; gap: 10px; }
.network-page .dynamic-fields .flex-row input { width: 100%; }

.network-page .search-btn {
  grid-column: span 3;
  min-height: 43px;
  margin: 2px 0 0;
  padding: 10px 14px;
  border: 1px solid #e95a13;
  border-radius: 11px;
  background: #e95a13;
  box-shadow: 0 8px 18px rgba(233, 90, 19, .18);
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .75rem;
  font-weight: 850;
}

.network-page .search-btn:hover { background: #d84f0d; box-shadow: 0 11px 22px rgba(233, 90, 19, .22); transform: translateY(-1px); }

.search-modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(20, 43, 61, .45);
  backdrop-filter: blur(11px);
}

.search-modal {
  position: relative;
  inset: auto;
  display: flex;
  flex-direction: column;
  width: min(760px, 100%);
  max-height: min(700px, calc(100dvh - 48px));
  overflow: hidden;
  border: 1px solid rgba(78, 119, 153, .2);
  border-radius: 21px;
  background: #fbfcfd;
  box-shadow: 0 28px 72px rgba(12, 31, 47, .32), inset 0 1px #ffffff;
  animation: network-results-in .3s cubic-bezier(.2, .8, .2, 1) both;
}

.search-modal::before {
  content: "";
  position: absolute;
  top: 0;
  right: 28px;
  left: 28px;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: #e95a13;
}

.search-modal-header {
  min-height: 70px;
  padding: 16px 18px;
  border-bottom: 1px solid rgba(78, 119, 153, .14);
  background: #fbfcfd;
}

.search-modal-header h3 { margin: 0; color: #29475e; font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 1rem; font-weight: 850; }
.search-modal-header span { display: grid; min-width: 28px; height: 28px; place-items: center; border: 1px solid rgba(233, 90, 19, .2); border-radius: 9px; color: #a83e0d; background: #fff3ec; font-size: .7rem; font-weight: 850; }
.search-modal-header .back-btn { display: grid; width: 36px; height: 36px; place-items: center; border: 1px solid rgba(78, 119, 153, .16); border-radius: 10px; color: #4e7799; background: #f1f5f7; font-size: .95rem; cursor: pointer; transition: .18s ease; }
.search-modal-header .back-btn:hover { color: #d84f0d; background: #fff3ec; }

.search-results-list { flex: 1 1; padding: 13px; overflow-y: auto; background: #f6f9fa; scrollbar-width: thin; scrollbar-color: #94a9ba transparent; }
.search-user { gap: 12px; margin-bottom: 8px; padding: 11px; border: 1px solid rgba(78, 119, 153, .14); border-radius: 14px; background: #ffffff; transition: .18s ease; }
.search-user:hover { border-color: rgba(233, 90, 19, .22); background: #fff8f4; box-shadow: 0 8px 18px rgba(30, 63, 88, .06); transform: translateX(2px); }
.search-avatar { flex: 0 0 auto; width: 43px; height: 43px; border: 2px solid #ffffff; border-radius: 12px; background: #4e7799; box-shadow: 0 4px 10px rgba(78, 119, 153, .18); font-size: .9rem; }
.search-user-info { min-width: 0; flex: 1 1; gap: 2px; }
.search-user-info strong { overflow: hidden; color: #29475e; font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: .82rem; font-weight: 850; text-overflow: ellipsis; white-space: nowrap; }
.search-user-info span, .search-user-info small { overflow: hidden; color: #71899b; font-size: .69rem; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }
.view-profile-btn-search { flex: 0 0 auto; padding: 8px 10px; border: 1px solid #e95a13; border-radius: 9px; background: #e95a13; box-shadow: 0 5px 12px rgba(233, 90, 19, .16); font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: .68rem; font-weight: 850; }
.view-profile-btn-search:hover { background: #d84f0d; }
.empty-search { color: #71899b; font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: .82rem; font-weight: 600; }
.empty-search h4 { color: #29475e; font-size: .95rem; }
.search-results-list .skeleton { background: #e5edf1; animation: network-result-pulse 1.15s ease-in-out infinite alternate; }

@keyframes network-fields-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
@keyframes network-results-in { from { opacity: 0; transform: translateY(20px) scale(.985); } to { opacity: 1; transform: translateY(0) scale(1); } }
@keyframes network-result-pulse { from { opacity: .55; } to { opacity: 1; } }

.network-page button:focus-visible,
.search-modal button:focus-visible,
.network-page input:focus-visible,
.network-page select:focus-visible { outline: 2px solid #e95a13; outline-offset: 2px; }

@media (max-width: 900px) {
  .network-page .role-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .network-page .dynamic-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .network-page .dynamic-fields .flex-row, .network-page .search-btn { grid-column: span 2; }
}

@media (max-width: 640px) {
  .network-page .advanced-search { margin: 22px 0 0; padding: 16px; border-radius: 16px; }
  .network-page .advanced-search::before { right: 18px; left: 18px; }
  .network-page .advanced-search h2 { font-size: .96rem; }
  .network-page .role-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; margin-bottom: 14px; }
  .network-page .role-card { min-height: 78px; padding: 9px 6px; border-radius: 11px; font-size: .65rem; }
  .network-page .dynamic-fields {
    width: 100%;
    min-width: 0;
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }
  .network-page .dynamic-fields .flex-row, .network-page .search-btn { grid-column: span 1; }
  .network-page .dynamic-fields .flex-row {
    width: 100%;
    min-width: 0;
    flex-direction: column;
    gap: 10px;
  }
  .network-page .dynamic-fields select {
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 50px;
    padding: 11px 38px 11px 13px;
    border-radius: 12px;
    font-size: 16px;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  [dir="rtl"] .network-page .dynamic-fields select {
    padding-right: 13px;
    padding-left: 38px;
  }
  .search-modal-overlay { padding: 0; align-items: flex-end; }
  .search-modal {
    width: 100%;
    max-width: 100vw;
    max-height: 88dvh;
    padding-bottom: env(safe-area-inset-bottom);
    border-width: 1px 0 0;
    border-radius: 20px 20px 0 0;
  }
  .search-modal-header { min-height: 64px; padding: 14px; }
  .search-results-list { padding: 10px; padding-bottom: 70px;}
  .search-user { align-items: center; padding: 10px; }
  .view-profile-btn-search { padding: 8px; font-size: .63rem; }
}



















/* .advanced-search{

    background:white;
    padding:20px;
  
    border-radius:12px;
  
    display:flex;
    flex-direction:column;
  
    gap:12px;
  
    margin-bottom:30px;
  
  }
  
  .advanced-search input,
  .advanced-search select{
  
    padding:10px;
  
    border-radius:8px;
  
    border:1px solid var(--accent-100);

  
  }
  
  .flex-row{
  
    display:flex;
    gap:10px;
  
  }

  .flex-row input{
    width: 200px;
  }
  
  .search-btn{
  
    background:var(--primary-100);
  
    color:white;
  
    border:none;
  
    padding:10px;
  
    border-radius:8px;
  
    cursor:pointer;
  
    display:flex;
    align-items:center;
    justify-content:center;
  
    gap:8px;
  
  } */
`, "",{"version":3,"sources":["webpack://./src/componentsL/AdvancedSearch.css"],"names":[],"mappings":"AAAA,cAAc;AACd,yBAAyB,YAAY,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,kDAAkD,EAAE,aAAa,EAAE;AACxJ,8BAA8B,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACjF,4BAA4B,eAAe,EAAE,aAAa,EAAE,kCAAkC,EAAE;AAChG,2BAA2B,aAAa,EAAE,eAAe,EAAE;AAC3D,2BAA2B,YAAY,EAAE,cAAc,EAAE,OAAO,EAAE,kBAAkB,EAAE;AACtF,gCAAgC,YAAY,EAAE,OAAO,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7K,kCAAkC,eAAe,EAAE;AACnD,gCAAgC,iBAAiB,EAAE,cAAc,EAAE,QAAQ,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,UAAU,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE;AAChL,sCAAsC,kBAAkB,EAAE;AAC1D,8CAA8C,yBAAyB,EAAE,kBAAkB,EAAE;AAC7F,0BAA0B,yBAAyB,YAAY,EAAE,CAAC,gCAAgC,UAAU,EAAE,EAAE;;AAEhH;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;;EAEnB,oCAAoC;EACpC,2BAA2B;;EAE3B,0CAA0C;EAC1C;;yCAEuC;;EAEvC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;;EAElB,mCAAmC;EACnC,0CAA0C;;EAE1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;;EAET,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,sEAAsE;EACtE,8BAA8B;;EAE9B,YAAY;EACZ,2BAA2B;;EAE3B;;qCAEmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,eAAe;;EAEf,aAAa;EACb,mBAAmB;;EAEnB;;;;MAII;EACJ,8BAA8B;;EAE9B,YAAY;EACZ,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;;EAET,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;;;AAIA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,UAAU;;EAEV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;;EAET,aAAa;EACb,mBAAmB;;EAEnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;EAChB,YAAY;;EAEZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;;;;AAKA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;EAClE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,iDAAiD,yBAAyB,EAAE;AAC5E,2BAA2B,kBAAkB,EAAE;;AAE/C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,2CAA2C;AAC7C;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,0CAA0C,mBAAmB,EAAE,SAAS,EAAE;AAC1E,gDAAgD,WAAW,EAAE;;AAE7D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kCAAkC,mBAAmB,EAAE,8CAA8C,EAAE,2BAA2B,EAAE;;AAEpI;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2CAA2C;EAC3C,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;EAClE,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA,0BAA0B,SAAS,EAAE,cAAc,EAAE,oEAAoE,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC9J,4BAA4B,aAAa,EAAE,eAAe,EAAE,YAAY,EAAE,mBAAmB,EAAE,uCAAuC,EAAE,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACrO,iCAAiC,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,yCAAyC,EAAE,mBAAmB,EAAE,cAAc,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAChQ,uCAAuC,cAAc,EAAE,mBAAmB,EAAE;;AAE5E,uBAAuB,SAAO,EAAE,aAAa,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,oCAAoC,EAAE;AACnJ,eAAe,SAAS,EAAE,kBAAkB,EAAE,aAAa,EAAE,yCAAyC,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACzK,qBAAqB,oCAAoC,EAAE,mBAAmB,EAAE,4CAA4C,EAAE,0BAA0B,EAAE;AAC1J,iBAAiB,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,8CAA8C,EAAE,gBAAgB,EAAE;AACnM,oBAAoB,YAAY,EAAE,SAAO,EAAE,QAAQ,EAAE;AACrD,2BAA2B,gBAAgB,EAAE,cAAc,EAAE,oEAAoE,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACtN,kDAAkD,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvK,2BAA2B,cAAc,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,6CAA6C,EAAE,oEAAoE,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC5R,iCAAiC,mBAAmB,EAAE;AACtD,gBAAgB,cAAc,EAAE,oEAAoE,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC3I,mBAAmB,cAAc,EAAE,iBAAiB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE,oEAAoE,EAAE;;AAE5H,+BAA+B,OAAO,UAAU,EAAE,0BAA0B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AAC7H,gCAAgC,OAAO,UAAU,EAAE,uCAAuC,EAAE,EAAE,KAAK,UAAU,EAAE,iCAAiC,EAAE,EAAE;AACpJ,kCAAkC,OAAO,YAAY,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE5E;;;qCAGqC,0BAA0B,EAAE,mBAAmB,EAAE;;AAEtF;EACE,2BAA2B,gDAAgD,EAAE;EAC7E,gCAAgC,gDAAgD,EAAE;EAClF,qEAAqE,mBAAmB,EAAE;AAC5F;;AAEA;EACE,iCAAiC,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE;EACvF,yCAAyC,WAAW,EAAE,UAAU,EAAE;EAClE,oCAAoC,iBAAiB,EAAE;EACvD,2BAA2B,gDAAgD,EAAE,QAAQ,EAAE,mBAAmB,EAAE;EAC5G,2BAA2B,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;EACvG;IACE,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,SAAS;EACX;EACA,qEAAqE,mBAAmB,EAAE;EAC1F;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA,wBAAwB,UAAU,EAAE,qBAAqB,EAAE;EAC3D;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;IAC3C,qBAAqB;IACrB,4BAA4B;EAC9B;EACA,uBAAuB,gBAAgB,EAAE,aAAa,EAAE;EACxD,uBAAuB,aAAa,EAAE,oBAAoB,CAAC;EAC3D,eAAe,mBAAmB,EAAE,aAAa,EAAE;EACnD,2BAA2B,YAAY,EAAE,iBAAiB,EAAE;AAC9D;;;;;;;;;;;;;;;;;;;;AAoBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA2DK","sourcesContent":["/* CONTAINER */\n.advanced-search-promo { padding:24px; border:1px solid #edc5ae; border-radius:18px; background:linear-gradient(135deg,#fff8f2,#f3f7fb); color:#17344f; }\n.advanced-search-promo-icon { color:#b4470d; font-size:24px; margin-bottom:12px; }\n.advanced-search-promo h3 { margin:0 0 12px; color:#17344f; font-size:clamp(1.2rem,3vw,1.6rem); }\n.advanced-search-promo p { color:#526c80; line-height:1.7; }\n.advanced-search-preview { display:flex; flex-wrap:wrap; gap:8px; margin:20px 0 10px; }\n.advanced-search-preview span { display:flex; gap:8px; align-items:center; padding:9px 12px; background:#fff; border:1px solid #dce5eb; border-radius:9px; font-size:.85rem; }\n.advanced-search-filter-preview { font-size:.8rem; }\n.advanced-search-promo button { padding:13px 20px; margin-top:8px; border:0; border-radius:10px; background:#b4470d; color:#fff; font:inherit; font-weight:700; cursor:pointer; }\n.advanced-search-promo button:hover { background:#923808; }\n.advanced-search-promo button:focus-visible { outline:3px solid #17344f; outline-offset:3px; }\n@media(max-width:480px) { .advanced-search-promo { padding:18px; }.advanced-search-promo button { width:100%; } }\n\n.advanced-search {\n  width: 100%;\n  margin: 20px auto;\n  padding: 22px;\n  border-radius: 24px;\n\n  background: rgba(255, 255, 255, .72);\n  backdrop-filter: blur(20px);\n\n  border: 1px solid rgba(255, 255, 255, .35);\n  /* box-shadow:\n    0 10px 30px rgba(0,0,0,.08),\n    inset 0 1px 0 rgba(255,255,255,.5); */\n\n  animation: fadeUp .45s ease;\n}\n\n.advanced-search h2 {\n  margin: 0 0 20px;\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--text-100);\n}\n\n/* ROLE GRID */\n.role-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  margin-bottom: 22px;\n}\n\n.role-card {\n  border: none;\n  cursor: pointer;\n  border-radius: 20px;\n  padding: 18px 12px;\n\n  background: rgba(255, 255, 255, .6);\n  border: 1px solid rgba(255, 255, 255, .35);\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n\n  transition: .25s;\n}\n\n.role-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, .08);\n}\n\n.role-card.active {\n  /* background: linear-gradient(135deg, var(--primary-100), #ffc371); */\n  background: var(--primary-100);\n\n  color: white;\n  transform: translateY(-4px);\n\n  box-shadow:\n    0 12px 28px rgba(0, 0, 0, .12),\n    0 0 0 3px rgba(255, 255, 255, .3);\n}\n\n.role-icon {\n  font-size: 24px;\n}\n\n/* FIELDS */\n.dynamic-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  animation: fadeUp .35s ease;\n}\n\n.dynamic-fields input,\n.dynamic-fields select {\n  width: 100%;\n  padding: 14px 16px;\n  border-radius: 14px;\n  border: 1px solid #e6e6e6;\n  outline: none;\n  font-size: 16px;\n  background: white;\n  transition: .2s;\n  box-sizing: border-box;\n}\n\n.dynamic-fields input:focus,\n.dynamic-fields select:focus {\n  border-color: var(--bg-200);\n  box-shadow: 0 0 0 4px rgba(0, 0, 0, .05);\n}\n\n/* FLEX */\n.flex-row {\n  display: flex;\n  gap: 12px;\n}\n\n.flex-row input {\n  flex: 1;\n}\n\n/* SEARCH BUTTON */\n.search-btn {\n  margin-top: 8px;\n  border: none;\n  cursor: pointer;\n\n  padding: 15px;\n  border-radius: 16px;\n\n  /* background: linear-gradient(\n    135deg,\n    var(--bg-100),\n    var(--bg-200)\n  ); */\n  background: var(--primary-100);\n\n  color: white;\n  font-size: 15px;\n  font-weight: 700;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n\n  transition: .25s;\n}\n\n.search-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 24px rgba(0, 0, 0, .15);\n}\n\n/* ANIMATION */\n@keyframes fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(18px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* MOBILE */\n@media (max-width: 700px) {\n  .role-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .advanced-search {\n    padding: 18px;\n    border-radius: 20px;\n  }\n\n  .role-card {\n    padding: 16px 10px;\n  }\n\n  .role-icon {\n    font-size: 22px;\n  }\n\n  .flex-row {\n    flex-direction: column;\n    gap: 14px;\n  }\n}\n\n\n\n.search-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, .35);\n  backdrop-filter: blur(8px);\n  z-index: 999;\n  animation: fadeUp .25s ease;\n}\n\n.search-modal {\n  position: absolute;\n  inset: 0;\n  background: white;\n  overflow-y: auto;\n}\n\n.search-modal-header {\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 2;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  padding: 18px 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.search-results-list {\n  padding: 20px;\n}\n\n.search-user {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n\n  padding: 14px;\n  margin-bottom: 12px;\n\n  border-radius: 18px;\n  background: #fafafa;\n}\n\n.search-avatar {\n  width: 55px;\n  height: 55px;\n  border-radius: 50%;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-weight: 700;\n  color: white;\n\n  background: var(--primary-200);\n}\n\n.search-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.search-user-info span {\n  color: #666;\n  font-size: 14px;\n}\n\n.search-user-info small {\n  color: #999;\n}\n\n.empty-search {\n  text-align: center;\n  padding: 60px 20px;\n  color: #777;\n}\n\n.skeleton-user {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.user-lines {\n  flex: 1;\n}\n\n.line {\n  height: 15px;\n  width: 70%;\n  margin-bottom: 10px;\n  border-radius: 8px;\n}\n\n.line.small {\n  width: 45%;\n}\n\n\n\n\n.view-profile-btn-search {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  background: var(--primary-100);\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* Advanced search and its result console. */\n.network-page .advanced-search {\n  position: relative;\n  box-sizing: border-box;\n  margin: 28px 0 0;\n  padding: 22px;\n  border: 1px solid rgba(78, 119, 153, .17);\n  border-radius: 20px;\n  background: #fbfcfd;\n  box-shadow: 0 15px 35px rgba(30, 63, 88, .08), inset 0 1px #ffffff;\n  backdrop-filter: none;\n}\n\n.network-page .advanced-search::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 28px;\n  left: 28px;\n  height: 3px;\n  border-radius: 0 0 4px 4px;\n  background: #4e7799;\n}\n\n.network-page .advanced-search h2 {\n  margin: 1px 0 17px;\n  color: #29475e;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: 1.04rem;\n  font-weight: 850;\n  letter-spacing: -.015em;\n}\n\n.network-page .role-grid {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 9px;\n  margin-bottom: 17px;\n}\n\n.network-page .role-card {\n  min-height: 92px;\n  padding: 12px 7px;\n  border: 1px solid rgba(78, 119, 153, .14);\n  border-radius: 13px;\n  color: #4e7799;\n  background: #f4f8fa;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .69rem;\n  font-weight: 750;\n  transition: .18s ease;\n}\n\n.network-page .role-card:hover {\n  border-color: rgba(233, 90, 19, .28);\n  color: #d84f0d;\n  background: #fff8f4;\n  box-shadow: 0 8px 18px rgba(30, 63, 88, .07);\n  transform: translateY(-2px);\n}\n\n.network-page .role-card.active {\n  border-color: #e95a13;\n  color: #ffffff;\n  background: #e95a13;\n  box-shadow: 0 9px 19px rgba(233, 90, 19, .2);\n  transform: translateY(-2px);\n}\n\n.network-page .role-card.active .role-icon svg { color: #ffffff !important; }\n.network-page .role-icon { font-size: 1.05rem; }\n\n.network-page .dynamic-fields {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  animation: network-fields-in .25s ease both;\n}\n\n.network-page .dynamic-fields input,\n.network-page .dynamic-fields select {\n  min-width: 0;\n  margin: 0;\n  padding: 11px 12px;\n  border: 1px solid rgba(78, 119, 153, .18);\n  border-radius: 11px;\n  color: #29475e;\n  background: #f1f5f7;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .77rem;\n  font-weight: 600;\n}\n\n.network-page .dynamic-fields input:focus,\n.network-page .dynamic-fields select:focus {\n  border-color: #e95a13;\n  background: #ffffff;\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);\n}\n\n.network-page .dynamic-fields .flex-row { grid-column: span 3; gap: 10px; }\n.network-page .dynamic-fields .flex-row input { width: 100%; }\n\n.network-page .search-btn {\n  grid-column: span 3;\n  min-height: 43px;\n  margin: 2px 0 0;\n  padding: 10px 14px;\n  border: 1px solid #e95a13;\n  border-radius: 11px;\n  background: #e95a13;\n  box-shadow: 0 8px 18px rgba(233, 90, 19, .18);\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .75rem;\n  font-weight: 850;\n}\n\n.network-page .search-btn:hover { background: #d84f0d; box-shadow: 0 11px 22px rgba(233, 90, 19, .22); transform: translateY(-1px); }\n\n.search-modal-overlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(20, 43, 61, .45);\n  backdrop-filter: blur(11px);\n}\n\n.search-modal {\n  position: relative;\n  inset: auto;\n  display: flex;\n  flex-direction: column;\n  width: min(760px, 100%);\n  max-height: min(700px, calc(100dvh - 48px));\n  overflow: hidden;\n  border: 1px solid rgba(78, 119, 153, .2);\n  border-radius: 21px;\n  background: #fbfcfd;\n  box-shadow: 0 28px 72px rgba(12, 31, 47, .32), inset 0 1px #ffffff;\n  animation: network-results-in .3s cubic-bezier(.2, .8, .2, 1) both;\n}\n\n.search-modal::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 28px;\n  left: 28px;\n  height: 3px;\n  border-radius: 0 0 4px 4px;\n  background: #e95a13;\n}\n\n.search-modal-header {\n  min-height: 70px;\n  padding: 16px 18px;\n  border-bottom: 1px solid rgba(78, 119, 153, .14);\n  background: #fbfcfd;\n}\n\n.search-modal-header h3 { margin: 0; color: #29475e; font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif; font-size: 1rem; font-weight: 850; }\n.search-modal-header span { display: grid; min-width: 28px; height: 28px; place-items: center; border: 1px solid rgba(233, 90, 19, .2); border-radius: 9px; color: #a83e0d; background: #fff3ec; font-size: .7rem; font-weight: 850; }\n.search-modal-header .back-btn { display: grid; width: 36px; height: 36px; place-items: center; border: 1px solid rgba(78, 119, 153, .16); border-radius: 10px; color: #4e7799; background: #f1f5f7; font-size: .95rem; cursor: pointer; transition: .18s ease; }\n.search-modal-header .back-btn:hover { color: #d84f0d; background: #fff3ec; }\n\n.search-results-list { flex: 1; padding: 13px; overflow-y: auto; background: #f6f9fa; scrollbar-width: thin; scrollbar-color: #94a9ba transparent; }\n.search-user { gap: 12px; margin-bottom: 8px; padding: 11px; border: 1px solid rgba(78, 119, 153, .14); border-radius: 14px; background: #ffffff; transition: .18s ease; }\n.search-user:hover { border-color: rgba(233, 90, 19, .22); background: #fff8f4; box-shadow: 0 8px 18px rgba(30, 63, 88, .06); transform: translateX(2px); }\n.search-avatar { flex: 0 0 auto; width: 43px; height: 43px; border: 2px solid #ffffff; border-radius: 12px; background: #4e7799; box-shadow: 0 4px 10px rgba(78, 119, 153, .18); font-size: .9rem; }\n.search-user-info { min-width: 0; flex: 1; gap: 2px; }\n.search-user-info strong { overflow: hidden; color: #29475e; font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif; font-size: .82rem; font-weight: 850; text-overflow: ellipsis; white-space: nowrap; }\n.search-user-info span, .search-user-info small { overflow: hidden; color: #71899b; font-size: .69rem; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }\n.view-profile-btn-search { flex: 0 0 auto; padding: 8px 10px; border: 1px solid #e95a13; border-radius: 9px; background: #e95a13; box-shadow: 0 5px 12px rgba(233, 90, 19, .16); font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif; font-size: .68rem; font-weight: 850; }\n.view-profile-btn-search:hover { background: #d84f0d; }\n.empty-search { color: #71899b; font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif; font-size: .82rem; font-weight: 600; }\n.empty-search h4 { color: #29475e; font-size: .95rem; }\n.search-results-list .skeleton { background: #e5edf1; animation: network-result-pulse 1.15s ease-in-out infinite alternate; }\n\n@keyframes network-fields-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }\n@keyframes network-results-in { from { opacity: 0; transform: translateY(20px) scale(.985); } to { opacity: 1; transform: translateY(0) scale(1); } }\n@keyframes network-result-pulse { from { opacity: .55; } to { opacity: 1; } }\n\n.network-page button:focus-visible,\n.search-modal button:focus-visible,\n.network-page input:focus-visible,\n.network-page select:focus-visible { outline: 2px solid #e95a13; outline-offset: 2px; }\n\n@media (max-width: 900px) {\n  .network-page .role-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .network-page .dynamic-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .network-page .dynamic-fields .flex-row, .network-page .search-btn { grid-column: span 2; }\n}\n\n@media (max-width: 640px) {\n  .network-page .advanced-search { margin: 22px 0 0; padding: 16px; border-radius: 16px; }\n  .network-page .advanced-search::before { right: 18px; left: 18px; }\n  .network-page .advanced-search h2 { font-size: .96rem; }\n  .network-page .role-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; margin-bottom: 14px; }\n  .network-page .role-card { min-height: 78px; padding: 9px 6px; border-radius: 11px; font-size: .65rem; }\n  .network-page .dynamic-fields {\n    width: 100%;\n    min-width: 0;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 10px;\n  }\n  .network-page .dynamic-fields .flex-row, .network-page .search-btn { grid-column: span 1; }\n  .network-page .dynamic-fields .flex-row {\n    width: 100%;\n    min-width: 0;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .network-page .dynamic-fields select {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    min-height: 50px;\n    padding: 11px 38px 11px 13px;\n    border-radius: 12px;\n    font-size: 16px;\n    line-height: 1.25;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  [dir=\"rtl\"] .network-page .dynamic-fields select {\n    padding-right: 13px;\n    padding-left: 38px;\n  }\n  .search-modal-overlay { padding: 0; align-items: flex-end; }\n  .search-modal {\n    width: 100%;\n    max-width: 100vw;\n    max-height: 88dvh;\n    padding-bottom: env(safe-area-inset-bottom);\n    border-width: 1px 0 0;\n    border-radius: 20px 20px 0 0;\n  }\n  .search-modal-header { min-height: 64px; padding: 14px; }\n  .search-results-list { padding: 10px; padding-bottom: 70px;}\n  .search-user { align-items: center; padding: 10px; }\n  .view-profile-btn-search { padding: 8px; font-size: .63rem; }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* .advanced-search{\n\n    background:white;\n    padding:20px;\n  \n    border-radius:12px;\n  \n    display:flex;\n    flex-direction:column;\n  \n    gap:12px;\n  \n    margin-bottom:30px;\n  \n  }\n  \n  .advanced-search input,\n  .advanced-search select{\n  \n    padding:10px;\n  \n    border-radius:8px;\n  \n    border:1px solid var(--accent-100);\n\n  \n  }\n  \n  .flex-row{\n  \n    display:flex;\n    gap:10px;\n  \n  }\n\n  .flex-row input{\n    width: 200px;\n  }\n  \n  .search-btn{\n  \n    background:var(--primary-100);\n  \n    color:white;\n  \n    border:none;\n  \n    padding:10px;\n  \n    border-radius:8px;\n  \n    cursor:pointer;\n  \n    display:flex;\n    align-items:center;\n    justify-content:center;\n  \n    gap:8px;\n  \n  } */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
